<template>
  <el-dialog class="role-dialog"
             :visible.sync="visible"
             :title="$t('role.distributionUser')"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :before-close="closePage"
             width="1200px">
    <!-- 左边表格 -->
    <div class="left-table">
      <el-form label-position="top"
               class="left-form"
               :inline="true"
               :model="dataForm">
        <el-row class="margb10">
          <el-col :span="12"
                  class="padt5">
            <!-- 姓名 -->
            <el-form-item :label="$t('user.name')">
              <el-input v-model="dataForm.userName"
                        :placeholder="$t('user.input')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"
                  class="padt5">
            <!-- 用户ID -->
            <el-form-item :label="$t('user.userID')">
              <el-input v-model="dataForm.userCode"
                        :placeholder="$t('user.input')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"
                  class="padt5">
            <!-- 公司名称 -->
            <el-form-item :label="$t('user.GWMcompany')">
              <el-select v-model="dataForm.orgId"
                         filterable
                         remote
                         clearable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="querySearchLeft">
                <el-option v-for="item in resultsLeft"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"
                  class="padt5">
            <!-- 职位 -->
            <el-form-item :label="$t('user.position')">
              <el-select v-model="dataForm.positionCode"
                         filterable
                         remote
                         clearable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="codeSearchLeft">
                <el-option v-for="(item,index) in positionlistLeft"
                           :key="index"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="left-search">
        <el-col :span="6">
          <el-col :span="24">
            <el-button class="M-search"
                       style="margin-bottom: 7px"
                       type="primary"
                       @click="queryInfo()">{{$t('user.query')}}</el-button>
          </el-col>
          <!-- 重置 -->
          <el-col :span="24">
            <el-button class="el-back M-search M-margin-l"
                       type="info"
                       @click="again">{{$t('reset')}}</el-button>
          </el-col>
        </el-col>
      </div>
      <div class="table-user table">
        <el-table :data="dataList"
                  border
                  v-loading="dataListLoading"
                  @selection-change="userListChange"
                  style="width: 100%">
          <el-table-column type="selection"
                           header-align="center"
                           align="center"
                           width="30">
          </el-table-column>
          <!-- 用户名 -->
          <el-table-column prop="userName"
                           :label="$t('user.name')"
                           width="94"
                           align="center">
          </el-table-column>
          <!-- 用户ID -->
          <el-table-column prop="userCode"
                           :label="$t('user.userID')"
                           width="104"
                           align="center">
          </el-table-column>
          <!-- 公司 -->
          <el-table-column prop="name"
                           :label="$t('user.GWMcompany')"
                           width="170"
                           align="center">
          </el-table-column>
          <!-- 职位 -->
          <el-table-column prop="positionName"
                           :label="$t('user.position')"
                           width="150"
                           align="center">
          </el-table-column>

        </el-table>
      </div>
      <div class="block"
           style="float: right;margin-top: 10px; margin-bottom: 10px">
        <el-pagination @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle"
                       :current-page="page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="limit"
                       layout="total, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
    <div class="middle-table">
      <div @click="allocationUser">
        <svg data-v-511f72fd=""
             aria-hidden="true"
             class="icon-svg">
          <use data-v-511f72fd=""
               xlink:href="#icon-doubleright"></use>
        </svg></div>
      <div @click="deleteAllocationUser">
        <svg data-v-511f72fd=""
             aria-hidden="true"
             class="icon-svg">
          <use data-v-511f72fd=""
               xlink:href="#icon-doubleleft"></use>
        </svg></div>
    </div>

    <!-- 右边表格 -->
    <div class="left-table right-table">
      <el-form label-position="top"
               class="left-form"
               :inline="true"
               :model="dataFormAllocated">
        <el-row class="margb10">
          <el-col :span="12"
                  class="padt5">
            <!-- 姓名 -->
            <el-form-item :label="$t('user.name')">
              <el-input v-model="dataFormAllocated.userName"
                        :placeholder="$t('user.input')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"
                  class="padt5">
            <!-- 用户ID -->
            <el-form-item :label="$t('user.userID')">
              <el-input v-model="dataFormAllocated.userCode"
                        :placeholder="$t('user.input')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"
                  class="padt5">
            <!-- 公司名称 -->
            <el-form-item :label="$t('user.GWMcompany')">
              <el-select v-model="dataFormAllocated.orgId"
                         filterable
                         remote
                         clearable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="querySearchRight">
                <el-option v-for="item in resultsRight"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"
                  class="padt5">
            <!-- 职位 -->
            <el-form-item :label="$t('user.position')">
              <el-select v-model="dataFormAllocated.positionCode"
                         filterable
                         remote
                         clearable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="codeSearchRight">
                <el-option v-for="(item,index) in positionlistRight"
                           :key="index"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="left-search">
        <el-col :span="6">
          <el-col :span="24">
            <el-button class="M-search"
                       style="margin-bottom: 7px"
                       type="primary"
                       @click="queryInfoCheck()">{{$t('user.query')}}</el-button>
          </el-col>
          <!-- 重置 -->
          <el-col :span="24">
            <el-button class="el-back M-search M-margin-l"
                       type="info"
                       @click="againAllocated">{{$t('reset')}}</el-button>
          </el-col>
        </el-col>
      </div>
      <div class="table-user table">
        <el-table :data="dataListAllocated"
                  border
                  v-loading="dataListLoading"
                  @selection-change="userAllocatedListChange"
                  style="width: 100%">
          <el-table-column type="selection"
                           header-align="center"
                           align="center"
                           width="30">
          </el-table-column>
          <!-- 用户名 -->
          <el-table-column prop="userName"
                           :label="$t('user.name')"
                           width="94"
                           align="center">
          </el-table-column>
          <!-- 用户ID -->
          <el-table-column prop="userCode"
                           :label="$t('user.userID')"
                           width="104"
                           align="center">
          </el-table-column>
          <!-- 公司 -->
          <el-table-column prop="name"
                           :label="$t('user.GWMcompany')"
                           width="170"
                           align="center">
          </el-table-column>
          <!-- 职位 -->
          <el-table-column prop="positionName"
                           :label="$t('user.position')"
                           width="150"
                           align="center">
          </el-table-column>
        </el-table>
      </div>
      <div class="block"
           style="float: right;margin-top: 10px; margin-bottom: 10px">
        <el-pagination @size-change="pageSizeChangeHandleAllocated"
                       @current-change="pageCurrentChangeHandleAllocated"
                       :current-page="pageAllocated"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="limitAllocated"
                       layout="total, prev, pager, next, jumper"
                       :total="totalAllocated">
        </el-pagination>
      </div>
    </div>
    <template slot="footer">
      <div class="dialog-footer">
        <el-button @click="closePage">{{ $t('logout') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      // 获取列表信息
      mixinViewModuleOptions: {
        getDataListURL: '/sys/role/getUser',
        getDataListIsPage: true
      },
      authType: '',
      orgType: '',
      roleId: '',
      roleType: '',
      visible: false,
      // 职位list
      positionlistLeft: [],
      positionlistRight: [],
      // 公司list
      resultsLeft: [],
      resultsRight: [],
      dataForm: {
        userName: '',
        userCode: '',
        name: '',
        positionCode: ''
      },
      dataFormAllocated: {
        userName: '',
        userCode: '',
        name: '',
        positionCode: ''
      },
      page: 1, // 当前页码
      limit: 10, // 每页数
      total: 0, // 总条数deleteURL
      pageAllocated: 1, // 当前页码
      limitAllocated: 10, // 每页数
      totalAllocated: 0, // 总条数deleteURL
      // 列表list
      dataList: [],
      dataListAllocated: [],
      // 等待转圈
      dataListLoading: false,
      // 左边list
      userList: [],
      // 右边list
      userAllocatedList: []
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  mounted () {
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.page = 1
        this.pageAllocated = 1
        this.refresh()
      })
    },
    closePage () {
      this.page = 1
      this.pageAllocated = 1
      this.dataForm = {
        userName: '',
        userCode: '',
        name: '',
        positionCode: ''
      }
      this.dataFormAllocated = {
        userName: '',
        userCode: '',
        name: '',
        positionCode: ''
      }
      this.visible = false
    },
    queryInfo () {
      this.page = 1
      this.getInfo()
    },
    // 获取信息
    getInfo () {
      this.$request.get('/sys/role/getUser',
        {
          authType: this.authType,
          orgType: this.orgType,
          roleId: this.roleId,
          roleType: this.roleType,
          page: this.page,
          limit: this.limit,
          ...this.dataForm
        }
      ).then((res, total, code, data) => {
        this.dataList = data.result
        this.total = total
      }).catch(() => { })
    },

    queryInfoCheck () {
      this.pageAllocated = 1
      this.getInfoCheck()
    },
    // 获取选中用户
    getInfoCheck () {
      this.$request.get('/sys/role/getAllocatedUser',
        {
          authType: this.authType,
          orgType: this.orgType,
          roleId: this.roleId,
          roleType: this.roleType,
          page: this.pageAllocated,
          limit: this.limitAllocated,
          ...this.dataFormAllocated
        }
      ).then((res, total, code, data) => {
        this.dataListAllocated = data.result
        this.totalAllocated = total
      }).catch(() => { })
    },
    // 重置
    again () {
      this.page = 1
      this.dataForm = {
        userName: '',
        userCode: '',
        name: '',
        positionCode: ''
      }
      this.getInfo()
    },
    // 重置
    againAllocated () {
      this.pageAllocated = 1
      this.dataFormAllocated = {
        userName: '',
        userCode: '',
        name: '',
        positionCode: ''
      }
      this.getInfoCheck()
    },
    // 分页, 每页条数
    pageSizeChangeHandle (val) {
      this.page = 1
      this.limit = val
      this.getInfo()
    },
    // 分页, 当前页
    pageCurrentChangeHandle (val) {
      this.page = val
      this.getInfo()
    },
    // 分页, 每页条数
    pageSizeChangeHandleAllocated (val) {
      this.pageAllocated = 1
      this.limitAllocated = val
      this.getInfoCheck()
    },
    // 分页, 当前页
    pageCurrentChangeHandleAllocated (val) {
      this.pageAllocated = val
      this.getInfoCheck()
    },
    // 获取公司的信息
    querySearchLeft (queryString) {
      this.$request.get('/sys/org/selectOrg',
        { name: queryString }
      ).then((res, total, code, data) => {
        this.resultsLeft = res
        this.resultsLeft = this.resultsLeft.map(item => {
          item['value'] = item.name
          return item
        })
      }).catch(() => { })
    },
    querySearchRight (queryString) {
      this.$request.get('/sys/org/selectOrg',
        { name: queryString }
      ).then((res, total, code, data) => {
        this.resultsRight = res
        this.resultsRight = this.resultsRight.map(item => {
          item['value'] = item.name
          return item
        })
      }).catch(() => { })
    },
    // 获取职位的信息
    codeSearchLeft (queryString) {
      this.$request.post('/sys/role/queryPositionByType',
        {
          positionName: queryString,
          orgType: this.orgType
        }
      ).then((res, total, code, data) => {
        this.positionlistLeft = res
      }).catch(() => { })
    },
    codeSearchRight (queryString) {
      this.$request.post('/sys/role/queryPositionByType',
        {
          positionName: queryString,
          orgType: this.orgType
        }
      ).then((res, total, code, data) => {
        this.positionlistRight = res
      }).catch(() => { })
    },
    userListChange (val) {
      this.userList = val.map(item => {
        return item.userId
      })
    },
    userAllocatedListChange (val) {
      this.userAllocatedList = val.map(item => {
        return item.userId
      })
    },
    /**
     * 分配
     */
    allocationUser: debounce(function () {
      if (this.userList.length > 0) {
        this.$request.post(`/sys/role/allocationUser`,
          {
            roleId: this.roleId,
            userIdList: this.userList
          }
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.page = 1
              this.refresh()
            }
          })
        }).catch(() => { })
      } else {
        this.$alert(this.$t('role.notNull'), this.$t('prompt.title')).then(() => {
        }).catch(() => { })
      }
    }, 3000, { 'leading': true, 'trailing': false }),
    /**
     * 取消分配
     */
    deleteAllocationUser: debounce(function () {
      if (this.userAllocatedList.length > 0) {
        this.$request.post(`/sys/role/deleteAllocationUser`,
          {
            roleId: this.roleId,
            userIdList: this.userAllocatedList
          }
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.pageAllocated = 1
              this.refresh()
            }
          })
        }).catch(() => { })
      } else {
        this.$alert(this.$t('role.notNull'), this.$t('prompt.title')).then(() => {
        }).catch(() => { })
      }
    }, 5000, { 'leading': true, 'trailing': false }),
    /**
     * 刷新两张表
     */
    refresh () {
      this.userIdList = []
      this.userAllocatedList = []
      this.getInfo()
      this.getInfoCheck()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  width: 90% !important;
}
.left-table {
  vertical-align: top;
  display: inline-block;
  overflow: hidden;
  width: 550px;
  .left-form {
    width: 420px;
    float: left;
  }
  .left-search {
    float: left;
    width: 130px;
    margin-top: 30px;
  }
}
.table-user {
  width: 550px;
}
.dialog-footer {
  margin: 10px;
  padding-bottom: 10px !important;
}
.el-dialog {
  width: 70% !important;
}
.middle-table {
  display: inline-block;
  width: 60px;
  text-align: center;
  font-size: 24px;
  margin-top: 100px;
  cursor: pointer;
  div {
    border: 1px solid #aaa;
    padding: 4px 0;
    margin: 4px;
    border-radius: 4px;
    margin-top: 22px;
  }
}
.middle-table div:hover {
  background: #cccccc;
}
.el-table .cell,
.el-table th div,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding: 0;
  text-align: center;
}
.el-table .cell,
.el-table th div,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding: 0 !important;
  text-align: center !important;
}
.el-table .cell,
.el-table th div,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding: 0 !important;
  text-align: center !important;
}
</style>
